import { render, staticRenderFns } from "./whatIsBoi.vue?vue&type=template&id=1b7f80b0&scoped=true"
import script from "./whatIsBoi.vue?vue&type=script&lang=js"
export * from "./whatIsBoi.vue?vue&type=script&lang=js"
import style0 from "./whatIsBoi.vue?vue&type=style&index=0&id=1b7f80b0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7f80b0",
  null
  
)

export default component.exports